<template>
  <v-container>
    <v-layout align-center>
      <v-flex>
        <v-text-field
          v-model="filter.search"
          :placeholder="$t('Search')"
          prepend-inner-icon="search"
          outline
          single-line
          hide-details
          @input="debouncedSearch"
        />
      </v-flex>
      <v-flex shrink>
        <v-btn color="primary" @click="handleAdd">
          <v-icon left>add</v-icon>
          {{ $t('Add') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="result.items"
      :pagination.sync="filter.pagination"
      :total-items="result.total"
      :rows-per-page-items="[10, 25, 50]"
      :loading="loading"
      class="elevation-1 mt-3"
    >
      <template #items="{ item }">
        <td class="text-xs-right">{{ item.id }}</td>
        <td>{{ item.lon_category_name }}</td>
        <td>{{ item.created_at | DateFormat('DD/MM/YYYY HH:mm:ss') }}</td>
        <td :style="{ width: 0 }">
          <div :style="{ display: 'flex', gap: '0.5rem' }">
            <v-btn icon flat class="ma-0" @click="handleEdit(item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon flat color="error" class="ma-0" @click="handleDelete(item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </div>
        </td>
      </template>
    </v-data-table>
    <FormDialog
      v-model="formDialog.open"
      :title="formDialog.data ? $t('edit_category') : $t('add_category')"
      :submitting="submitting"
    >
      <template #default="{ id }">
        <Form
          :form-id="id"
          :value="formDialog.data"
          :disabled="submitting"
          @submit="handleSubmit"
        />
      </template>
    </FormDialog>
  </v-container>
</template>

<script>
import FormDialog from './FormDialog'
import Form from './Form'
import lonCategoryApi from '@/api/lon-category'
import { mapGetters } from 'vuex'
import { debounce } from 'lodash'

export default {
  components: {
    FormDialog,
    Form
  },
  data() {
    return {
      result: {
        items: [],
        total: 0
      },
      filter: {
        search: '',
        pagination: {
          page: 1,
          rowsPerPage: 10
        }
      },
      loading: false,
      formDialog: {
        open: false,
        data: undefined
      },
      debouncedSearch: undefined,
      submitting: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    headers() {
      return [
        {
          text: 'ID',
          value: 'id',
          sortable: false,
          align: 'right'
        },
        {
          text: this.$t('Category'),
          value: 'category',
          sortable: false
        },
        {
          text: 'Timestamp',
          value: 'timestamp',
          sortable: false
        },
        {
          value: 'action',
          sortable: false
        }
      ]
    }
  },
  created() {
    this.debouncedSearch = debounce(() => {
      this.filter.pagination.page = 1
      this.fetch()
    }, 500)
    this.fetch()
  },
  methods: {
    async fetch() {
      try {
        this.loading = true
        const response = await lonCategoryApi.getCategories({
          page_id: this.selectedBot.pageid,
          search: this.filter.search,
          limit: this.filter.pagination.rowsPerPage,
          offset: this.filter.pagination.rowsPerPage * (this.filter.pagination.page - 1)
        })
        const { data, totla } = response.data
        this.result = {
          items: data,
          total: Number(totla)
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.formDialog = {
        open: true,
        data: undefined
      }
    },
    handleEdit(item) {
      this.formDialog = {
        open: true,
        data: {
          id: item.id,
          name: item.lon_category_name
        }
      }
    },
    async handleDelete(item) {
      const { value } = await this.$swal({
        title: this.$t('category_delete_confirm', { name: item.lon_category_name }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })

      if (!value) return

      try {
        this.loading = true
        await lonCategoryApi.deleteCategory(item.id, {
          page_id: this.selectedBot.pageid
        })
        this.fetch()
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async handleSubmit(form) {
      const payload = {
        page_id: this.selectedBot.pageid,
        lon_category_name: form.name
      }

      try {
        this.submitting = true
        if (this.formDialog.data) {
          await lonCategoryApi.updateCategory(this.formDialog.data.id, payload)
        } else {
          await lonCategoryApi.createCategory(payload)
          this.filter = {
            ...this.filter,
            search: '',
            pagination: {
              ...this.filter.pagination,
              page: 1
            }
          }
        }
        this.formDialog.open = false
        this.fetch()
        this.$store.dispatch('lon/fetchCategoryOptions', true)
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/LonBroadcast/Category/index.vue